import React, { Component } from 'react';
import { connect } from 'react-redux';

//import { withRouter } from 'react-router-dom';
import { getFormFields, isFormValid, onTextChange, onDropDownChange } from '../../../utile/formHelper';
import _, { cloneDeep } from 'lodash';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Button } from 'primereact/button';
import Service from './../../services';
import { Toast } from 'primereact/toast';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import withRouter from '../../lib/withRouter';
import LoadingComponent from '../../loadingComponent';
import { InputSwitch } from 'primereact/inputswitch';
import { Checkbox } from 'primereact/checkbox';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { MailIcon } from '../../svgIcons';
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import Authorizer, { PERMISSIONS } from '../../session/authorizer';
import VehicleStaffAssignment from './VehicleStaffAssignment';

const createVehicleFields = require('./createVehicle.json');
const formFields = createVehicleFields;

class CreateVehicle extends Component {
    constructor(props) {
        super(props);
        this.formFields = getFormFields(createVehicleFields);
        this.state = {
            vehicle: this.props?.editData?._id ? this.props?.editData : this.formFields.data,
            formValidations: this.formFields.formValidations,
            boards: [],
            classes: [],
            isGps: this.props?.editData?.isGps || false,
            videoRec: this.props?.editData?.videoRec || false,
            vehicleType: [
                { label: 'Bus', value: 'BUS' },
                { label: 'Car', value: 'CAR' },
                { label: 'Mini Bus', value: 'MINI BUS' },
                { label: 'Mini Van', value: 'MINI VAN' },
                { label: 'Van', value: 'VAN' },
                { label: 'Electric Bus', value: 'ELECTRIC BUS' },
                { label: 'Auto', value: 'AUTO' },
                { label: 'Jeep', value: 'JEEP' }
            ],
            fuelTypes: [
                { label: 'Petrol', value: 'PETROL' },
                { label: 'Diesel', value: 'DIESEL' },
                { label: 'CNG', value: 'CNG' },
                { label: 'Electric', value: 'ELECTRIC' }
            ],
            vehicleCategory: [
                { label: 'Owned', value: 'OWNED' },
                { label: 'Leased', value: 'LEASED' },
                { label: 'Rented', value: 'RENTED' }
            ],
            airCondition: [
                { label: 'AC', value: 1 },
                { label: 'NON-AC', value: 2 }
            ],
            purchaseDate: null,
            isShowCreateSuccess: false,
            hideUpdateButton: false,
            sectionsData: {},
            showStaffAssignment: false,
            createdVehicleId: null,
            createdVehicleName: null
        };

        this.service = new Service();
    }

    async componentDidMount() {
        await this.props.getBranchesLatest(true);
        if (this.props?.editData?._id) {
            // Convert boolean acNonAC to dropdown value (1=AC, 2=NON-AC)
            const acNonACValue = this.props?.editData?.acNonAC === true ? 1 : 2;
            this.setState((prevState) => ({
                vehicle: { ...prevState.vehicle, acNonAC: acNonACValue }
            }));
        }
    }

    onCreateVehicle = async () => {
        this.setState({ isLoading: true });
        const academicYear = localStorage.getItem('userAcademicYear');
        let bodyForApi = cloneDeep(this.state.vehicle);

        const formStatus = isFormValid(createVehicleFields, this.formFields.formValidations, bodyForApi);

        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
                isLoading: false
            });
        } else {
            if (!this.state.vehicle._id) {
                const payload = {
                    vehicleRegistrationNo: bodyForApi?.vehicleRegistrationNo,
                    vehicleType: bodyForApi?.vehicleType,
                    vehicleName: bodyForApi?.vehicleName,
                    seatingCapacity: bodyForApi?.seatingCapacity,
                    vehicleCategory: bodyForApi?.vehicleCategory,
                    acNonAC: bodyForApi?.acNonAC == 1 ? true : false,
                    purchasedOn: bodyForApi?.purchasedOn,
                    isGps: this.state.isGps,
                    videoRec: this.state.videoRec,
                    branchId: bodyForApi?.branchId,
                    fuelType: bodyForApi?.fuelType
                };
                let url = `${baseUrlAdmin}/transport-vehicle?academicYear=${academicYear}`;
                try {
                    const res = await this.service.post(url, payload, true);
                    if (res?.res?.status && res.status) {
                        this.setState({ isLoading: false });
                        this.toast.show({ severity: 'success', summary: 'Created successfully', detail: res?.res?.message, life: 3000 });

                        // Ask if user wants to assign staff now
                        const createdVehicle = res?.res?.data;
                        this.setState({
                            createdVehicleId: createdVehicle._id,
                            createdVehicleName: createdVehicle.vehicleName,
                            showStaffAssignment: true
                        });
                    } else {
                        this.setState({ isLoading: false });
                        const errorMsg = res?.errMessage || res?.res?.errMessage || 'Some error occurred';
                        this.toast.show({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                } catch (e) {
                    this.setState({ isLoading: false });
                    console.log(e);
                    this.toast.show({ severity: 'error', summary: 'Error', detail: e?.message || 'Some error occurred', life: 3000 });
                }
            } else if (this.state.vehicle._id) {
                const payload = {
                    _id: this.state.vehicle._id,
                    vehicleRegistrationNo: bodyForApi?.vehicleRegistrationNo,
                    vehicleType: bodyForApi?.vehicleType,
                    vehicleName: bodyForApi?.vehicleName,
                    seatingCapacity: bodyForApi?.seatingCapacity,
                    vehicleCategory: bodyForApi?.vehicleCategory,
                    acNonAC: bodyForApi?.acNonAC == 1 ? true : false,
                    purchasedOn: bodyForApi?.purchasedOn,
                    isGps: this.state.isGps,
                    videoRec: this.state.videoRec,
                    academicYear: academicYear,
                    branchId: bodyForApi?.branchId,
                    fuelType: bodyForApi?.fuelType
                };
                let url = `${baseUrlAdmin}/transport-vehicle`;
                try {
                    const res = await this.service.put(url, payload, true);
                    if (res?.res?.status && res.status) {
                        this.setState({ isLoading: false });
                        this.toast.show({ severity: 'success', summary: 'Updated successfully', detail: res?.res?.message, life: 3000 });
                        this.props.onCancel();
                        this.props.getVehicleData();
                    } else {
                        this.setState({ isLoading: false });
                        const errorMsg = res?.errMessage || res?.res?.errMessage || 'Some error occurred';
                        this.toast.show({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                } catch (e) {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: e?.message || 'Some error occurred', life: 3000 });
                }
            }
        }
    }

    render() {
        const { vehicle, formValidations } = this.state;
        const { defaultLanguage, onCancel } = this.props;
        const langType = defaultLanguage;
        return (
            <>
                <div className=" mt-3">
                    <div className="grid grid-nogutter md:grid-cols-2 lg:grid-cols-3 mx-5 row-gap-3">
                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label w-auto">
                                Vehicle Type<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetDropdown
                                    // icon={<MailIcon />}
                                    optionLabel="label"
                                    optionValue="value"
                                    width={345}
                                    value={vehicle.vehicleType}
                                    options={this.state.vehicleType}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'vehicleType', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations');
                                    }}
                                    placeholder={
                                        <div className="flex justify-content-start align-items-center">
                                            <span>Select Vehicle Type</span>
                                        </div>
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['vehicleType'].isValid && <p className="p-error">{formValidations.fields['vehicleType'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Vehicle Name<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={'black'} />}
                                    width={345}
                                    value={vehicle.vehicleName}
                                    onChange={(e) => onTextChange(e.target.value, 'vehicleName', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations')}
                                    placeholder="Vehicle Name"
                                />
                            </div>
                            {formValidations && !formValidations.fields['vehicleName'].isValid && <p className="p-error">{formValidations.fields['vehicleName'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Registration Number<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={'black'} />}
                                    width={345}
                                    value={vehicle.vehicleRegistrationNo}
                                    onChange={(e) => onTextChange(e.target.value.toUpperCase(), 'vehicleRegistrationNo', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations')}
                                    placeholder="Registered Vehicle Number"
                                />
                            </div>
                            {formValidations && !formValidations.fields['vehicleRegistrationNo'].isValid && <p className="p-error">{formValidations.fields['vehicleRegistrationNo'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Seating Capacity<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    // icon={<MailIcon width={24} height={24} color={'black'} />}
                                    width={345}
                                    value={vehicle.seatingCapacity}
                                    keyfilter="int"
                                    onChange={(e) => {
                                        onTextChange(e.target.value, 'seatingCapacity', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations');
                                    }}
                                    placeholder="Seating Capacity"
                                />
                            </div>
                            {formValidations && !formValidations.fields['seatingCapacity'].isValid && <p className="p-error">{formValidations.fields['seatingCapacity'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Vehicle Category<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetDropdown
                                    // icon={<MailIcon />}
                                    optionLabel="label"
                                    optionValue="value"
                                    width={345}
                                    value={vehicle.vehicleCategory}
                                    disabled={this.state.hideUpdateButton}
                                    options={this.state.vehicleCategory}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'vehicleCategory', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations');
                                    }}
                                    placeholder={
                                        <div className="flex justify-content-start align-items-center">
                                            <span>Select Vehicle Category</span>
                                        </div>
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['vehicleCategory'].isValid && <p className="p-error">{formValidations.fields['vehicleCategory'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Airconditioning<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetDropdown
                                    // icon={<MailIcon />}
                                    optionLabel="label"
                                    optionValue="value"
                                    width={345}
                                    value={vehicle.acNonAC}
                                    options={this.state.airCondition}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'acNonAC', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations');
                                    }}
                                    placeholder={
                                        <div className="flex justify-content-start align-items-center">
                                            <span>Select AirCondition Type</span>
                                        </div>
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['acNonAC'].isValid && <p className="p-error">{formValidations.fields['acNonAC'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Purchased On<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetCalendar
                                    // icon={<MailIcon width={24} height={24} color={'black'} />}
                                    width={345}
                                    calendarMode={'single'}
                                    value={vehicle.purchasedOn ? new Date(vehicle.purchasedOn) : null}
                                    onChange={(e) => {
                                        onTextChange(e.target.value, 'purchasedOn', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations');
                                    }}
                                    maxDate={new Date()}
                                    placeholder="Purchased On"
                                />
                            </div>
                            {formValidations && !formValidations.fields['purchasedOn'].isValid && <p className="p-error">{formValidations.fields['purchasedOn'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Fuel Type<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetDropdown
                                    // icon={<MailIcon />}
                                    optionLabel="label"
                                    optionValue="value"
                                    width={345}
                                    value={vehicle.fuelType}
                                    options={this.state.fuelTypes}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'fuelType', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations');
                                    }}
                                    placeholder={
                                        <div className="flex justify-content-start align-items-center">
                                            <span>Select Fuel Type</span>
                                        </div>
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['fuelType'].isValid && <p className="p-error">{formValidations.fields['fuelType'].errorMsg}</p>}
                        </div>

                        <div className="col-12 md:col-4 lg:col-4">
                            <p className="add-vehicle-field-label">
                                Branch<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetDropdown
                                    // icon={<MailIcon />}
                                    optionLabel="name"
                                    optionValue="key"
                                    width={345}
                                    value={vehicle.branchId}
                                    options={this.props.branchData}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'branchId', this, formFields, vehicle, formValidations, 'vehicle', 'formValidations');
                                    }}
                                    placeholder={
                                        <div className="flex justify-content-start align-items-center">
                                            <span>Select Branch</span>
                                        </div>
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['branchId'].isValid && <p className="p-error">{formValidations.fields['branchId'].errorMsg}</p>}
                        </div>
                    </div>
                    <div className="grid mx-6 md:grid-cols-2 lg:grid-cols-3 ">
                        <div className=" col-span-1  mt-8 flex ">
                            <InputSwitch onChange={(e) => this.setState({ isGps: e.value })} checked={this.state.isGps} />
                            <p className="add-vehicle-field-label w-auto ml-2 text-lg">Enable GPS</p>
                        </div>
                    </div>

                    <div className="grid mx-6 md:grid-cols-2 lg:grid-cols-3">
                        <div className="col-span-1x mt-7 flex">
                            <Checkbox className="mt-1" onChange={(e) => this.setState({ videoRec: e.target.checked })} checked={this.state.videoRec} />
                            <p className="add-vehicle-field-label w-auto ml-3 text-lg">Video Recording Available</p>
                        </div>
                    </div>

                    <div className="flex justify-content-center mb-4 gap-3 mt-8">
                        <Authorizer permId={this.props.editData ? PERMISSIONS.UPDATE_VEHICLE_MANAGEMENT : PERMISSIONS.CREATE_VEHICLE_MANAGEMENT}>
                            <Button label={this.props.editData ? 'Update Vehicle' : 'Add Vehicle'} className="confirmDialogAcceptBtn px-6 mr-5 w-19rem" onClick={() => this.onCreateVehicle()} />
                        </Authorizer>
                        <Button label="Cancel" className="confirmDialogCancelBtn" onClick={onCancel} />
                    </div>
                </div>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {(this.state.isLoading || this.props.isBranchLoading || this.props.isLoading) && (
                    <>
                        <LoadingComponent />
                    </>
                )}

                {this.state.showStaffAssignment && (
                    <VehicleStaffAssignment
                        visible={this.state.showStaffAssignment}
                        onHide={() => {
                            this.setState({ showStaffAssignment: false });
                            this.props.onCancel();
                            this.props.getVehicleData();
                        }}
                        vehicleId={this.state.createdVehicleId}
                        vehicleName={this.state.createdVehicleName}
                        branchId={this.state.vehicle.branchId}
                        accountId={this.props.orgId}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._id,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        []
});

export default connect(mapStateToProps, {
    getBoardsData,
    getBranchesLatest
})(withRouter(CreateVehicle));
